var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',[_c('ul',{staticStyle:{"list-style-type":"none"}},_vm._l((_vm.titles),function(title){return _c('li',{key:title.name,on:{"click":function($event){return _vm.jumpPage(title.page)}}},[_c('button',{staticClass:"item"},[_vm._v(" "+_vm._s(title.name)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }